import axios from 'axios'

const TokenService = {
  getToken: () => {
    return localStorage.getItem('token')
  },
  setToken: (token) => {
    localStorage.setItem('token', "Bearer " + token)
    return "Bearer " + token
  },
  removeToken: () => {
    localStorage.removeItem('token')
  },
}

export default TokenService
